/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { createStyles, makeStyles } from '@mui/styles'

import { Logger, LoggerTypes } from '../../../utils'
import { buttonModes, buttonTypes, Button } from '../../buttons'
import { FormSearchField } from '../../forms'
import { Icon, iconNames } from '../../icons'
import './style.scss'
import { userRightTypes } from '../../../constants'
import { AccessControl } from '../../AccessControl'

const useStyles = makeStyles((theme) =>
  createStyles({
    searchField: {
      border: `1px solid ${theme.palette.primary.main}`
    },
    iconStyle: {
      color: theme.palette.primary.main
    }
  })
)

export const AttributeToolsHeader = ({
  currentProject,
  currentScenario,
  attributeName,
  terms,
  onSearch,
  onAdd,
  onImport
}) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()

  const tooltip = currentScenario
    ? t(`attributes.${attributeName}.create.scenario`)
    : currentProject
    ? t(`attributes.${attributeName}.create.project`)
    : t(`attributes.${attributeName}.create.global`)

  const hasSearch = typeof onSearch === 'function'
  const hasAdd = typeof onAdd === 'function'
  const hasImport = typeof onImport === 'function'

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeToolsHeader.render()', {
    currentProject,
    currentScenario,
    attributeName,
    terms,
    hasSearch,
    hasAdd,
    hasImport
  })

  return (
    <div className="AttributePanelHeader">
      <div className="buttons-actions-bar">
        <AccessControl
          userPermissions={[
            currentScenario === null ? userRightTypes.PROJECT_ATTRIBUTES_EDIT : userRightTypes.SCENARIO_EDIT
          ]}
          renderNoAccess={() => <></>}
        >
          {hasAdd && (
            <Button
              className="button-action"
              mode={buttonModes.TABS_ACTION}
              type={buttonTypes.BUTTON}
              tooltip={tooltip}
              icon={<Icon name={iconNames.PLUS} size={14} className="button-icon" />}
              onClick={onAdd}
            />
          )}
          {hasImport && (
            <Button
              className="button-action"
              mode={buttonModes.TABS_ACTION}
              type={buttonTypes.BUTTON}
              tooltip={t('global.import_global_library')}
              icon={<Icon name={iconNames.UPLOAD} size={14} className="button-icon" />}
              onClick={onImport}
            />
          )}
        </AccessControl>
      </div>
      {hasSearch && (
        <FormSearchField
          className={styleClasses.searchField}
          iconClassName={styleClasses.iconStyle}
          searchTerm={terms}
          onSearch={onSearch}
          widthSize={(!hasImport && hasAdd) || (!hasAdd && hasImport) ? '82%' : !hasAdd && !hasImport ? '94%' : null}
        />
      )}
    </div>
  )
}

AttributeToolsHeader.displayName = 'AttributeToolsHeader'

AttributeToolsHeader.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  attributeName: PropTypes.oneOf(['products', 'variables', 'resources', 'weather_data', 'locations', 'parameters']),
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onImport: PropTypes.func
}

AttributeToolsHeader.defaultProps = {
  currentProject: null,
  currentScenario: null,
  attributeName: 'weather_data',
  terms: '',
  onSearch: null,
  onAdd: null,
  onImport: null
}
